import { Col } from 'antd';
import CustomButton from '../../../../../../v2-components/Antd/Button';

export const renderButtons = (status, handleCancel, handleNext) => {
	if (status === 100) {
		return (
			<>
				<Col span={12}>
					<CustomButton style={{ backgroundColor: '#D2000C', color: '#FFFFFF' }} onClick={handleCancel}>
						Rechazar
					</CustomButton>
				</Col>
				<Col span={12}>
					<CustomButton style={{ backgroundColor: '#088926', color: '#FFFFFF' }} onClick={handleNext}>
						Aprobar
					</CustomButton>
				</Col>
			</>
		);
	}
};
